import React, { useContext } from 'react';
import cn from 'classnames';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import EmptyState from './_partials/EmptyState';
import IncomeChartPanel from './_partials/ChartPanel/presets/IncomeChartPanel';
import SubscribersChartPanel from './_partials/ChartPanel/presets/SubscribersChartPanel';
import {
  SubscriptionsChartPointType,
  SubscriptionsStatType,
} from '../../../../types/subscriptionsSection';
import MobileContent from './_partials/MobileContent';

import s from './SubscriptionCenter.scss';

export interface Props {
  moduleId: number;
  className?: string;
  stats?: SubscriptionsStatType[];
  chartData?: SubscriptionsChartPointType[];
}

const SubscriptionCenter: React.FC<Props> = ({
  moduleId,
  className,
  stats = [],
  chartData = [],
}) => {
  const isMobile = useContext(MobileContext);

  if (stats.length < 1 || chartData.length < 1) {
    return <EmptyState />;
  }

  if (isMobile) {
    return (
      <MobileContent
        moduleId={moduleId}
        className={className}
        stats={stats}
        chartData={chartData}
      />
    );
  }

  return (
    <div className={cn(s['root'], className)}>
      <IncomeChartPanel
        className={s['chart-panel']}
        chart={chartData}
        stats={stats && stats[0]}
      />
      <SubscribersChartPanel
        className={s['chart-panel']}
        chart={chartData}
        stats={stats && stats[0]}
      />
    </div>
  );
};
SubscriptionCenter.displayName = 'SubscriptionCenter';

export default SubscriptionCenter;
